import { createReducer } from 'redux-starter-kit';
import * as newPlatformActions from '../Actions/action_new_platform';

const initialState = {
  purchases: [],
  subscription: {},
  initialized: false,
  loading: false,
};

const reducer = createReducer(initialState, {
  [newPlatformActions.fetchBillingOnNewPlatform.started]: (state) => {
    state.initialized = true;
    state.loading = true;
  },
  [newPlatformActions.fetchBillingOnNewPlatform.succeeded]: (
    state,
    { payload }
  ) => ({ ...payload, initialized: true, loading: false }),
});

export default reducer;
